import { render, staticRenderFns } from "./exportImage.vue?vue&type=template&id=4c1491a2&scoped=true"
import script from "./exportImage.vue?vue&type=script&lang=js"
export * from "./exportImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1491a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1491a2')) {
      api.createRecord('4c1491a2', component.options)
    } else {
      api.reload('4c1491a2', component.options)
    }
    module.hot.accept("./exportImage.vue?vue&type=template&id=4c1491a2&scoped=true", function () {
      api.rerender('4c1491a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/complaintWorkOrder/component/exportImage.vue"
export default component.exports